var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9695 6.5489C19.381 6.80681 18.751 6.98424 18.087 7.06471C18.7645 6.65836 19.2825 6.01561 19.5295 5.2499C18.894 5.61976 18.191 5.88766 17.4435 6.0391C16.8475 5.40135 15.9955 5 15.05 5C13.2375 5 11.7685 6.46794 11.7685 8.27724C11.7685 8.53764 11.8 8.78754 11.8545 9.02445C9.128 8.897 6.711 7.5875 5.0945 5.60927C4.8105 6.09108 4.649 6.65087 4.649 7.26013C4.649 8.40019 5.2295 9.39981 6.107 9.98758C5.5705 9.97209 5.0655 9.82365 4.623 9.57924V9.61872C4.623 11.2086 5.753 12.5341 7.253 12.836C6.9795 12.9085 6.6875 12.9504 6.391 12.9504C6.1805 12.9504 5.9795 12.93 5.779 12.893C6.201 14.1945 7.409 15.1421 8.849 15.1706C7.7295 16.0478 6.3105 16.5705 4.7815 16.5705C4.521 16.5705 4.261 16.5581 4 16.5266C5.4585 17.4562 7.18 18 9.0395 18C15.073 18 18.37 13.0044 18.37 8.67809C18.37 8.54014 18.37 8.39969 18.3595 8.25875C19.003 7.80042 19.56 7.21965 20 6.5614L19.9695 6.5489Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.2016e4c0.svg";
export { ForwardRef as ReactComponent };